import './styles/tabs.less';
import React from 'react';
import { Layout, Tabs, Dropdown, Button, Menu, Icon } from 'antd';
import BaseComponent from './BaseComponent';
import { Switch, Route } from 'dva/router';
import P404 from '../basic/Pages/404';
import store from 'store2';
const NotFound = P404
const { Content } = Layout;
const TabPane = Tabs.TabPane;

function getTitle(pathName) {
  const map = window.dva_router_pathMap[pathName];
  return <div className="tab-title">{map ? map.title : 'Tag'}</div>;
}

export default class TabsLayout extends BaseComponent {
  constructor(props) {
    const {
      location: { pathname }
    } = props;
    super(props);
    this.state = this.setCurPanes(pathname, []);
  }

  componentWillReceiveProps(nextProps) {
    const {
      location: { pathname },
      search
    } = this.props;
    const nextpathname = nextProps.location.pathname;
    const nextsearch = nextProps.location.search;
    if (pathname !== nextpathname) {
      const newState = this.setCurPanes(nextpathname);
      this.setState(newState);
    } else {
      if (search && nextsearch !== search) {
        const newState = this.setCurPanes(nextpathname);
        this.setState(newState);
      }
    }
  }

  setCurPanes = (nextpathname, _panes) => {
    const { childRoutes, location: { pathname } } = this.props;
    let panes = _panes || this.state.panes;
    
    const stateObj = {
      activeKey: nextpathname,
      noMatch : false,
      // key: nextpathname
    }

    // if(pathname.includes(nextpathname+'/') && pathname !== nextpathname && !this.changed) {
    //   // const prev = panes.filter(val => val.key === pathname)[0]
    //   // if(!prev.props.cached) {
    //   //   panes = panes.filter(val => val.key !== pathname)
    //   //   stateObj.key = new Date().getTime()
    //   // }
    //   panes = panes.filter(val => val.key !== pathname)
    //   stateObj.key = new Date().getTime()
    // } 
    // else if(nextpathname.includes(pathname) && pathname !== nextpathname && !this.changed) {
    //   stateObj.key = new Date().getTime()
    // }

    this.changed = false

    const existPane = panes.some(item => item.key === nextpathname);
    if (existPane) {
      stateObj.panes = panes

    } else {
      const nextPanes = childRoutes.filter(item => item.key === nextpathname);
      if (nextPanes.length) {
        stateObj.panes = panes.concat(nextPanes)

      } else if (
        window.dva_router_pathMap[nextpathname] &&
        window.dva_router_pathMap[nextpathname].parentPath
      ) {
        // childRoutes中如果没有(分两种情况,确实没有,或可能是一个子路由在subChildRoute中)
        // 如果是子路由
        const parentPath = window.dva_router_pathMap[nextpathname].parentPath;
        return this.setCurPanes(parentPath, panes);
      } else {
        stateObj.panes = panes
        stateObj.noMatch = true
      }
    }
    return stateObj
  };

  componentWillUnmount() {
    store.session.remove('searchMap')
  }

  /**
     * 清除searchBar缓存
     */
   _cacheClear() {
    const _key = window.location.hash
    const _searchMap = store.session('searchMap') || []
    const _index = _searchMap.findIndex(val => val.key === _key)

    if(_index !== -1) {
        _searchMap[_index].value = {}
        store.session('searchMap', _searchMap)
    }
  }

  onChange = activeKey => {
    this.changed = true
    this.history.push(activeKey);
  };

  onRemove = targetKey => {
    let { activeKey, panes } = this.state;
    let lastIndex;
    panes.forEach((pane, i) => {
      if (pane.key === targetKey) {
        lastIndex = i - 1;
      }
    });
    const newpanes = panes.filter(pane => pane.key !== targetKey);
    if (newpanes.length && activeKey === targetKey) {
      activeKey = lastIndex >= 0 ? newpanes[lastIndex].key : newpanes[0].key;
    }
    this.setState({ panes: newpanes, activeKey }, () => {
      if (activeKey !== targetKey) this.onChange(activeKey);
      if ((newpanes && newpanes.length === 0) && lastIndex < 0) this.onChange('/home')
    });
    this._cacheClear()
  };

  onRemoveOther = () => {
    let { activeKey, panes } = this.state;
    const newpanes = panes.filter(pane => pane.key === activeKey);
    this.setState({ panes: newpanes });
  };

  onRemoveAll = () => {
    this.setState({ panes: [], activeKey: null }, () => {
      let { initMenu } = this.props
      initMenu && initMenu()
      this.onChange('/home')
    });
    this._cacheClear()
  };

  onTabsActions = ({ key }) => {
    let { activeKey } = this.state;
    switch (key) {
      case 'close':
        this.onRemove(activeKey);
        break;
      case 'closeother':
        this.onRemoveOther();
        break;
      case 'closeall':
        this.onRemoveAll();
        break;
      default:
        break;
    }
  };

  render() {
    const { panes, activeKey, noMatch, key } = this.state;
    
    return (
      <Layout className="full-layout tabs-layout">
        <Content>
          <Switch>
            {noMatch ? (
              <Route component={NotFound} />
            ) : (
                <Tabs
                  // key={key}
                  animated={false}
                  hideAdd
                  type="editable-card"
                  className="lanif-tabs-content"
                  tabBarExtraContent={
                    <Dropdown
                      overlay={
                        <Menu onClick={this.onTabsActions}>
                          <Menu.Item key="close">关闭当前</Menu.Item>
                          <Menu.Item key="closeother">关闭其它</Menu.Item>
                          <Menu.Item key="closeall">关闭所有</Menu.Item>
                        </Menu>
                      }
                    >
                      <Button type="primary" ghost>
                        操作
                      <Icon type="down" />
                      </Button>
                    </Dropdown>
                  }
                  onEdit={this.onRemove}
                  onChange={this.onChange}
                  activeKey={activeKey}
                >
                  {panes.map(item => (
                    <TabPane style={{ backgroundColor: '#F0F2F5', padding: 15 }} tab={getTitle(item.key)} key={item.key}>
                      {item}
                    </TabPane>
                  ))}
                </Tabs>
              )}
          </Switch>
        </Content>
      </Layout>
    );
  }
}
